import { LoaderScreen } from '@/components/Elements';
import { AnalyzeLayout } from '@/features/analyze/components/AnalyzeLayout';
import { FoamTreeSelectItem } from '@/features/analyze/components/FoamTreeSelectItem';
import { FoamTreeView } from '@/features/analyze/components/FoamTreeView';
import { PerPageSelect } from '@/features/analyze/components/PerPageSelect';
import { ResultNotFond } from '@/features/analyze/components/ResultNotFond';
import { useAnalyzeClustering } from '@/features/analyze/hooks/useAnalyzeClustering';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const TreeMap = () => {
  const { t } = useTranslation();
  const { formattedTreemapData, isLoading, selectedArticle, onSelectTarget } =
    useAnalyzeClustering();
  const analyzeHeaderRef = useRef<HTMLDivElement>(null);
  const headerHeight = analyzeHeaderRef.current?.getBoundingClientRect().bottom;

  if (!isLoading && !formattedTreemapData.length) {
    return (
      <AnalyzeLayout>
        <ResultNotFond />
      </AnalyzeLayout>
    );
  }

  return (
    <AnalyzeLayout analyzeHeaderRef={analyzeHeaderRef}>
      <div
        className="flex size-full gap-x-3 p-3"
        style={{ height: `calc(100vh - ${headerHeight}px)` }}
      >
        <div className="h-full w-2/3">
          {isLoading ? (
            <LoaderScreen contained />
          ) : (
            <FoamTreeView
              data={formattedTreemapData}
              onSelectTarget={onSelectTarget}
            />
          )}
        </div>
        <div className="flex h-full w-1/3 flex-col">
          <div className="flex items-center text-xs">
            {t('表示件数')}:
            <PerPageSelect />
          </div>

          <div className="flex-1 overflow-y-auto rounded-md bg-white p-5">
            {selectedArticle && (
              <FoamTreeSelectItem selectedArticle={selectedArticle} />
            )}
          </div>
        </div>
      </div>
    </AnalyzeLayout>
  );
};
